<template>
  <div>
    <SOOrdersTable :data="rows" :loading="isLoading" @refresh="loadOrders" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue';
import { eventBus } from '../../eventBus';
import { log, error as logError } from '../../utils/DebugLogger';
import { useFiltro } from '../../composables/useFiltro';
import { useSOOrders } from '../../composables/useSOOrders';
import SOOrdersTable from './SOOrdersTable.vue';

const { init } = useFiltro();
const { rows, isLoading, fetchServiceOrders } = useSOOrders();

// fetchServiceOrders rethrows after filling error.value; the page only logs.
const loadOrders = (): void => {
  fetchServiceOrders().catch((err) =>
    logError('SOOrdersPage', 'loadOrders', 'fetch failed (error already in error.value)', err));
};

const handleFilterUpdated = (): void => {
  log('SOOrdersPage', 'event:filter.updated', 'Received');
  loadOrders();
};

onMounted(() => {
  log('SOOrdersPage', 'mounted', 'Initializing filter and loading service orders');
  init();
  loadOrders();
  eventBus.on('filter.updated', handleFilterUpdated);
});

onBeforeUnmount(() => {
  log('SOOrdersPage', 'beforeUnmount', 'Cleaning up event listeners');
  eventBus.off('filter.updated', handleFilterUpdated);
});
</script>

<style scoped>
</style>
